import React from "react";
import { Starburst } from "../common";

const ITEMS = [
  "The Future of Cleaning",
  "Licensed & Insured",
  "Apartment Turnover Specialists",
  "Satisfaction Focused",
  "Serving Denton, TX",
  "Responsive Service",
];

const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      className="relative bg-jet-ink py-5 overflow-hidden border-y border-white/10"
      data-testid="marquee"
    >
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {row.map((t, i) => (
          <div key={i} className="flex items-center">
            <span className="mx-8 text-lg md:text-2xl font-display font-medium text-white/90">
              {t}
            </span>
            <Starburst className="h-4 w-4 md:h-5 md:w-5 text-jet-amber shrink-0" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
